import React, { useEffect, useState } from 'react';

function Image({ hoveredSentence, path_story }) {
  const [imagePath, setImagePath] = useState(
    `${process.env.PUBLIC_URL}/${path_story.image_path}/${hoveredSentence !== null && hoveredSentence !== undefined ? hoveredSentence.index : 'title'}.png`
  );

  useEffect(() => {
    setImagePath(
      `${process.env.PUBLIC_URL}/${path_story.image_path}/${hoveredSentence !== null && hoveredSentence !== undefined ? hoveredSentence.index : 'title'}.png`
    );
  }, [hoveredSentence, path_story.image_path]);

  useEffect(() => {
    console.log(`Image Path: ${imagePath}`);
  }, [imagePath]);

  return (
    <div className='bg-white border border-gray-300'>
      <img className="object-scale-down" alt="generated" src={imagePath} />
    </div>
  );
}

export default Image;